import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { InputLabel, Grid } from "@material-ui/core";
import Info from "../Components/Info";
import "../Components/Checkbox.css";

// Element's style attributes
const useStyles = makeStyles((theme) => ({
  inputTitle: {
    fontWeight: 700,
    fontSize: 11,
    color: "#8C90A2",
    marginBottom: 5,
  },
  input: {
    border: "0.5px solid #D5D5D5",
    boxSizing: "border-box",
    borderRadius: "2px",
    height: 35,
    width: 280,
  },
  toggleButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: 10,
  },
  toggleTitle: {
    fontWeight: 700,
    fontSize: 11,
    color: "#8C90A2",
  },
  toggleButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: 150,
    marginRight: 50,
  },
  addNewSection: {
    border: "1px solid #162436",
    fontWeight: 700,
    borderRadius: 2,
    background: "#162436",
    color: "#fff",
    margin: "22px 0px 0px 40px",
  },
  removeNewSection: {
    border: "1px solid #162436",
    fontWeight: 700,
    borderRadius: 2,
    background: "transparent",
    margin: "22px 0px 0px 40px",
  },
  lastRemoveNewSection: {
    border: "1px solid #162436",
    fontWeight: 700,
    borderRadius: 2,
    background: "transparent",
  },
}));

function CredentialDefinition({
  getValues,
  setValue,
  register,
  index,
  errors,
  addVariableSection,
  removeVariableSection,
  variables,
  setVariables,
  isLast,
}) {
  useEffect(() => {
    setTimeout(() => {
      //=> This is the work-around for reRender when the item is removed from form section ==> https://github.com/react-hook-form/react-hook-form/issues/2578#issuecomment-672844831
      for (let i = 0; i < variables.attributes.length; i++) {
        setValue(`attributes[${index}].name`, variables.attributes[index].name);
        setValue(
          `attributes[${index}].description`,
          variables.attributes[index].description
        );
        setValue(
          `attributes[${index}].value`,
          variables.attributes[index].value
        );
        setValue(
          `attributes[${index}].masked_flag`,
          variables.attributes[index].masked_flag
        );
        setValue(
          `attributes[${index}].user_provided_flag`,
          variables.attributes[index].user_provided_flag
        );

        setIsDisabled(variables.attributes[index]?.user_provided_flag);
        setMaskedValue(variables.attributes[index]?.masked_flag);
      }
    });
  }, [variables]);

  const [isDisabled, setIsDisabled] = useState(
    getValues(`attributes[${index}].user_provided_flag`)
  );
  const [maskedValue, setMaskedValue] = useState(false);

  function changeSwitchHandler(e, name, indexI) {
    if (name === "user_provided_flag") {
      const isTrue = getValues(`attributes[${indexI}].user_provided_flag`);
      setIsDisabled(isTrue);
      if (isTrue) {
        setValue(`attributes[${indexI}].value`, "");
      }
    } else {
      setMaskedValue(getValues(`attributes[${indexI}].masked_flag`));
      if (e.target.checked === false) {
        setValue(`attributes[${index}].value`, "");
      }
    }
  }

  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Grid container>
        <Grid item md={4} xs={12} id={index}>
          <InputLabel className={classes.inputTitle} htmlFor="credentialName">
            {t("CONTENT.ADD-NEW-CREDENTIAL.VARIABLE-NAME")}<span className="mandatory-field">*</span>
          </InputLabel>

          <input
            className={classes.input}
            type="text"
            name={`attributes[${index}].name`}
            ref={register({ required: true })}
          />
          {errors.attributes &&
            errors.attributes[index] &&
            errors.attributes[index].name?.type === "required" && (
              <p className="required-visible">
                {t("MESSAGES.AUTH-PAGES.ADD-NEW-CREDENTIAL.REQUIRED")}!
              </p>
            )}
        </Grid>
        <Grid item md={4} xs={12}>
          <div>
            <InputLabel
              className={classes.inputTitle}
              htmlFor="credentialDescription"
            >
              {t("CONTENT.ADD-NEW-CREDENTIAL.VARIABLE-DESCRIPTION")}
            </InputLabel>
          </div>
          <input
            className={classes.input}
            type="text"
            name={`attributes[${index}].description`}
            ref={register({ required: false })}
          />
        </Grid>
        <Grid item md={3} xs={10}>
          <InputLabel className={classes.inputTitle} htmlFor="credentialValue">
            {t("CONTENT.ADD-NEW-CREDENTIAL.VARIABLE-VALUE")}<span className="mandatory-field">*</span>
          </InputLabel>
          <input
            className={classes.input}
            name={`attributes[${index}].value`}
            type={maskedValue ? "password" : "text"}
            ref={register({ required: !isDisabled })}
            disabled={isDisabled}
          />
          {!isDisabled &&
            errors.attributes &&
            errors.attributes[index] &&
            errors.attributes[index].value?.type === "required" && (
              <p className="required-visible">
                {t("MESSAGES.AUTH-PAGES.ADD-NEW-CREDENTIAL.REQUIRED")}!
              </p>
            )}
        </Grid>
        <Grid item md={1} xs={2}>
          {isLast && (
            <button
              className={classes.addNewSection}
              onClick={(e) => {
                addVariableSection(e, index);
              }}
              id={index}
            >
              +
            </button>
          )}
          {index >= 1 && (
            <button
              className={
                isLast ? classes.lastRemoveNewSection : classes.removeNewSection
              }
              onClick={(e) => {
                removeVariableSection(e, index);
              }}
              id={index}
            >
              -
            </button>
          )}
        </Grid>
        <Grid item md={6} xs={12}>
          <div className={classes.toggleButtonsContainer}>
            <div className={classes.toggleButtons}>
              <Info value={t("CONTENT.ADD-NEW-CREDENTIAL.MASK-INFO")} />
              <InputLabel className={classes.toggleTitle} htmlFor="isMasked">
                {t("CONTENT.ADD-NEW-CREDENTIAL.IS-MASKED")}
              </InputLabel>
              <input
                className="apple-switch"
                type="checkbox"
                name={`attributes[${index}].masked_flag`}
                onClick={(e) => changeSwitchHandler(e, "masked_flag", index)}
                ref={register()}
                checked={maskedValue}
                onChange={(e) => { }}
              />
            </div>
            <div className={classes.toggleButtons}  style={{display: "none"}}>
              <Info
                value={t("CONTENT.ADD-NEW-CREDENTIAL.WHO-WILL-DETERMINE")}
              />
              <InputLabel
                className={classes.toggleTitle}
                htmlFor="userWillDetermine"
              >
                {t("CONTENT.ADD-NEW-CREDENTIAL.USER-WILL-DETERMINE")}
              </InputLabel>
              <input
                className="apple-switch"
                type="checkbox"
                name={`attributes[${index}].user_provided_flag`}
                onClick={(e) =>
                  changeSwitchHandler(e, "user_provided_flag", index)
                }
                onChange={(e) => { }}
                ref={register()}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <div className="hr-container">
        <hr />
      </div>
    </>
  );
}

export default CredentialDefinition;
